import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/application/invoiceRequest/main"));

const InvoiceRequest = () => {

    return(

        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
      
    )
};

export default InvoiceRequest;